import React, { ReactNode, useState } from "react";
import NavigationDropdown from "../../../generic/navigationDropdown";
import "../../../../assets/scss/components/toc/orderBook/obContainer/obContainerMob.scss";
import { secNavOptions, scrlStCls, newOfferOptions } from "../obConstants";
import { ObScrollService } from "./../../../service/orderBook/obScrollService";
import NavigationTag from "../../../generic/navigationTag";
import { useParams } from "react-router-dom";
import { IListObj } from "../../../types/genericTypes";

export interface IObContainerMobProps {
	priNavOptions: Array<IListObj>;

	instComp?: ReactNode;
	isPriNavHidden?: boolean;
	// primary market related props
	handleInstNav?: (value: any) => void;
}

const ObContainerMob: React.FC<IObContainerMobProps> = (props: IObContainerMobProps) => {
	const [isFixed, setIsFixed] = useState(false);
	const { secNav, inst } = useParams<{ secNav: string; inst: string }>(); //section navigation,page navigation, primary market instrument

	// (e.target as HTMLElement).scrollTop > (props.instNav ? 60 : 40) ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header

		(e.target as HTMLElement).scrollTop > (inst ? 60 : 40) ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);

		setTimeout(() => {
			ObScrollService(isFixed);
		});
	}

	return (
		<section
			className={"outer_container container_mob" + (props.isPriNavHidden ? " selectActive" : "") + (isFixed ? " obScrollActive" : "")}
			onScroll={onContainerScroll}
			id={scrlStCls.pContId}
		>
			<section className="ob_container lyCont">
				<section className="ob_view_mob ly_view_mob ">
					<div className={"ob_mob_hdr ly_mob_hdr " + (props.isPriNavHidden ? " hide" : "")}>
						<div className={"ob_title ly_title "}>
							<NavigationDropdown
								type="sec_nav"
								defaultValue={secNav || "equity"}
								dropdownOptions={secNavOptions()}
								onSelect={() => {}}
							/>
						</div>
						<div className="ob_hdr_mob ly_hdr_mob ">
							{inst && (
								<div className="taLeft mg-l15">
									<NavigationTag
										defaultValue={inst || "today"}
										tagList={newOfferOptions}
										onSelect={props.handleInstNav ? props.handleInstNav : () => {}}
									/>
								</div>
							)}
						</div>
					</div>
					<div className={"ob_content_mob ly_content_mob  obTableData"}>{props.instComp}</div>
				</section>
			</section>
		</section>
	);
};

export default ObContainerMob;
